import React, { useContext, useEffect } from 'react';
import classNames from 'classnames';
import uniqueId from 'uniqid';

import { StoreContext } from '../../context/store-context';
import { stripURL } from '../../utils';

const ns = 'add-to-cart';

const AddToCart = ({
	product,
	variant,
	location,
	variantId,
	quantity,
	available,
	price,
	setQuickShopOpen,
	setShowErrors,
	variants,
	sellingPlanGroup,
	selectedSellingPlanId,
	...props
}) => {
	// const outOfStock = variants.every(v => { return v.availableForSale === false; });

	const {
		addVariantToCart,
		loading,
		didJustAddToCart,
		onFlyoutCartOpen,
	} = useContext(StoreContext);

	const rootClassnames = classNames({
		[`${ ns }`]: true,
		disabled: !variantId || !available || loading,
	});

	const addToCart = e => {
		e.preventDefault();
		if (!e.currentTarget.classList.contains('disabled')) {
			addVariantToCart(
				variantId,
				quantity,
				selectedSellingPlanId,
				sellingPlanGroup,
				product,
				location
			);

			let dataLayerPrice = variant?.price || product.priceRangeV2.minVariantPrice.amount;

			if (selectedSellingPlanId && sellingPlanGroup) {
				dataLayerPrice -= (dataLayerPrice
					* (sellingPlanGroup.include.product.discount_amount / 100));
				dataLayerPrice = dataLayerPrice.toFixed(2);
			}
		} else {
			setShowErrors(true);
		}
	};

	useEffect(() => {
		if (didJustAddToCart) {
			setTimeout(() => {
				onFlyoutCartOpen({ location });
				if (setQuickShopOpen) {
					setQuickShopOpen(false);
				}
			}, 500);
		}
	}, [didJustAddToCart, onFlyoutCartOpen, setQuickShopOpen]);

	return (
		<button
			type={'submit'}
			className={rootClassnames}
			onClick={addToCart}
			// disabled={!variantId || !available || loading}
			{...props}
		>
			{loading || didJustAddToCart ? (
				// eslint-disable-next-line react/jsx-no-useless-fragment
				<>
					{!didJustAddToCart ? (
						'Updating…'
					) : (
						<>
							Added to cart
							{' '}
							<svg
								width={'14'}
								height={'14'}
								fill={'none'}
								xmlns={'http://www.w3.org/2000/svg'}
							>
								<path
									d={'M5.019 10.492l-2.322-3.17A.796.796 0 013.91 6.304L6.628 9.14a1.056 1.056 0 11-1.61 1.351z'}
									fill={'currentColor'}
								/>
								<path
									d={'M5.209 10.693a1.11 1.11 0 01-.105-1.6l5.394-5.88a.757.757 0 011.159.973l-4.855 6.332a1.11 1.11 0 01-1.593.175z'}
									fill={'currentColor'}
								/>
								<path
									d={'M5.331 7.806c.272.326.471.543.815.163.345-.38-.108.96-.108.96l-1.123-.363.416-.76z'}
									fill={'currentColor'}
								/>
							</svg>
						</>
					)}
				</>
			) : (
				<>
					{/* {!variantId && !available ? ( */}
					{!available ? (
						`Out of Stock`
					) : (
						`Add to Cart ${ price ? `- ${ price }` : '' }`
					)}
				</>
			)}
		</button>
	);
};

export default AddToCart;
